import { getUsersPsychologistsList } from './reducer';
import { AppDispatch } from '..';
import { HttpHandler } from '../../api/HttpHandler';
import { environment } from '../../enviroments';
import { UsersListOfSpecialistsType } from './types';

export const getUsersPsychologistsListThunk =
  () =>
  async (dispatch: AppDispatch): Promise<Array<UsersListOfSpecialistsType>> => {
    try {
      const { data: usersPsychologistList } = await HttpHandler({
        method: 'GET',
        url: `${environment.CLIENT_APP_URL}/client/profile/specialists`,
      });
      dispatch(getUsersPsychologistsList(usersPsychologistList?.data));

      return usersPsychologistList;
    } catch (error: any) {
      return [];
    }
  };
